import React from 'react';
import { Container } from './styles';
import { InputTypes } from '../Input';

interface DateInputProps {
  dateString: string;
  setDateString(x: string): void
  type?: InputTypes
}

export const DateInput = ({ dateString, setDateString, type = 'primary' }: DateInputProps) => {
  const handleChange = (value: string) => {
    const digits = value.replace(/\D/g, '').slice(0, 8);

    if (digits.length <= 2) {
      setDateString(digits);
      return;
    }

    if (digits.length <= 4) {
      setDateString(`${digits.slice(0, 2)}/${digits.slice(2)}`);
      return;
    }

    setDateString(`${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4)}`);
  };

  return (
    <Container type={type}>
      <input
        type="text"
        inputMode="numeric"
        maxLength={10}
        value={dateString}
        placeholder="dd/mm/aaaa"
        onChange={(e) => {
          handleChange(e.target.value);
        }}
      />
    </Container>
  )
}
